export default function Loader({ size = "default" }) {
  const sizeClasses = {
    small: "h-4 w-4 border-2 border-t-2",
    medium: "h-8 w-8 border-4 border-t-4",
    default: "h-64 w-64 border-8 border-t-8"
  };

  return (
    <div
      className={`animate-spin border-t-turquoise ease-linear rounded-full ${sizeClasses[size]}`}
      role="status"
    />
  );
}
